import { action as apiAction } from 'api/Api'

type Payload = {
  name: string
  validateAddress?: boolean
}

export default (payload: Payload) => async () => {
  const { name, validateAddress } = payload

  await apiAction('ChangeIncomingMail', {
    name,
    validateAddress
  })
}
